import * as React from 'react';
import { useState, useEffect } from "react";
import { NavigateNextOutlined, NavigateBeforeOutlined, LastPageOutlined, FirstPageOutlined, FirstPage } from '@mui/icons-material';

export interface IPageListProps {
    totalResults: number,
    pageSize: number,
    pageNumber: number,
    moveToPage: (page: number) => void
}

export const PageList = (props: IPageListProps) => {
    const [scrollPageToBottom, setScrollPageToBottom] = useState(false);

    const buildPageArray = () => {
        const arr = [] as number[];

        if (props.totalResults > 0) {
            var startPage = 1;
            var lastPage = Math.ceil(props.totalResults / props.pageSize);

            for (var p = startPage; p < lastPage + 1; p++) {
                arr.push(p);
            }
        }

        return arr;
    };

    const lastPage = Math.ceil(props.totalResults / props.pageSize);
    const pageArray = buildPageArray();

    const scrollToBottomOfPage = () => {
        window.scrollTo(0, document.documentElement.scrollHeight - window.innerHeight);
    }

    const moveToPage = (page: number) => {
        props.moveToPage(page);
        setScrollPageToBottom(true);
    }

    const scrollCurrentPageNumberIntoView = () => {
        let docPageListElement = document.getElementsByClassName("pl-page-list")[0] as HTMLElement;

        let docPageNumberElements = document.getElementsByClassName("pl-current-page");
        if (docPageNumberElements.length > 0) {
            let currentDocPageElement = docPageNumberElements[0] as HTMLElement;
            let midPoint = docPageListElement.offsetWidth / 2;
            let offset = currentDocPageElement.offsetLeft - docPageListElement.offsetLeft - midPoint;
            docPageListElement.scroll(offset, 0); //Scroll the document page selector list so the currently selected page is on visible
        }
    }

    const scrollToBottomIfRequired = () => {
        let pageScrollPercent = window.pageYOffset / (document.documentElement.scrollHeight - window.innerHeight);
        if (scrollPageToBottom || pageScrollPercent > 0.85) {
            setScrollPageToBottom(false);
            scrollToBottomOfPage();
        }
    }

    useEffect(() => {
        window.addEventListener("resize", scrollCurrentPageNumberIntoView);
        return () => window.removeEventListener("resize", scrollCurrentPageNumberIntoView);
    }, []);

    useEffect(() => {
        scrollCurrentPageNumberIntoView();
        scrollToBottomIfRequired();
    });

    return (
        <>
            {lastPage > 1 &&
                <div className={"pl-container" + (pageArray.length < 2 ? " single-page" : " many-pages") + (props.pageNumber === 1 ? " on-first-page" : props.pageNumber === lastPage ? " on-last-page" : "")}>
                    <span className="pl-first-page" onClick={() => { if (props.pageNumber > 1) moveToPage(1); }}><FirstPageOutlined /></span>
                    <span className="pl-previous-page" onClick={() => { if (props.pageNumber > 1) moveToPage(props.pageNumber - 1); }}><NavigateBeforeOutlined /></span>
                    <span className="pl-page-list">
                        {pageArray.map(
                            p => {
                                return <span key={p} className={(p === props.pageNumber ? "pl-current-page " : "") + "pl-page-number"} onClick={() => { moveToPage(p); }}>{p}</span>
                            }
                        )}
                    </span>
                    <span className="pl-next-page" onClick={() => { if (props.pageNumber < lastPage) moveToPage(props.pageNumber + 1); }}><NavigateNextOutlined /></span>
                    <span className="pl-last-page" onClick={() => { if (props.pageNumber < lastPage) moveToPage(lastPage); }}><LastPageOutlined /></span>
                </div>
            }
        </>
    )
};